import React from "react";

import { history } from "../_helpers";
import { serverUrl, nativeOAuthProviders } from "../_constants";
import { NATIVE_OAUTH_KEY } from "../CardApp/nativeBridge";

// Промежуточная страница входа через провайдера для мобильного приложения «визитка».
// Открывается **в браузере** (обёртка шлёт сюда системным Linking.openURL), поэтому
// живёт в основной веб-сборке, а не в CardApp: внутри приложения её никогда не видно.
//
// Смысл страницы — поставить маркер в localStorage фронт-домена. redirect_uri у нас один
// и общий с вебом, и на странице колбэка отличить «этот возврат для приложения» от
// обычного входа в кабинет больше нечем. Маркер ставится именно здесь, в контексте
// браузера, — из WebView он лёг бы в другой origin, и читать было бы нечего.
class OAuthStartPage extends React.Component {
  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const provider = params.get("provider");
    const type = params.get("type");

    // Сюда можно прийти с любой строкой в адресе, а по ней строится переход на бэкенд.
    if (nativeOAuthProviders.indexOf(provider) < 0) {
      history.replace("/login");
      return;
    }

    localStorage.setItem(NATIVE_OAUTH_KEY, String(Date.now()));

    // replace, а не href: страница промежуточная, в истории браузера ей делать нечего —
    // иначе «назад» со страницы провайдера вернёт на неё и запустит цепочку заново.
    window.location.replace(
      serverUrl +
        "auth/" +
        provider +
        (type ? "?type=" + encodeURIComponent(type) : "")
    );
  }

  render() {
    return <div>Loading...</div>;
  }
}

export { OAuthStartPage };
